<template>
  <v-dialog
    v-model="show"
    width="640"
  >
    <v-card
      class="dialogBackground"
      :disabled="loading"
    >
      <v-row
        no-gutters
        class="dialogTitleBackground white--text px-2 py-1 mb-2"
        align="center"
      >
        <span>{{ this.user.id > 0 ? 'Изменение' : 'Добавление' }} пользователя</span>
        <v-spacer></v-spacer>
        <v-btn
          small
          icon
          dark
          @click="cancelClick"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-card-text>
        <v-row
          align="center"
          justify="center"
          no-gutters
          class="mx-0"
        >
          <v-col cols="12 px-0">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Логин"
              v-model="user.login"
              :error-messages="objectErrors(this.$v.user.login)"
              :counter="this.$v.user.login.$params.maxLength.max"
              @input="$v.user.login.$touch()"
              @blur="$v.user.login.$touch()"
            ></v-text-field>
          </v-col>

          <v-col cols="6 pl-0 pr-1">
            <v-select
              label="Роль в системе"
              v-model="user.role"
              :error-messages="objectErrors(this.$v.user.role)"
              @input="$v.user.role.$touch()"
              @blur="$v.user.role.$touch()"
              :loading="rolesLoading"
              :items="roles"
              :itemColor="$store.getters['settings/dark'] ? 'white' : 'black'"
            ></v-select>
          </v-col>

          <v-col cols="6 pr-0 pl-1">
            <CargoTypeSelector
              v-model="user.cargoTypeID"
              :canAny="true"
              :error-messages="objectErrors(this.$v.user.cargoTypeID)"
            ></CargoTypeSelector>
          </v-col>

          <v-col
            cols="8"
            class="pr-1 pl-0"
          >
            <v-text-field
              autocomplete="off"
              type="text"
              label="Фамилия Имя Отчество"
              v-model="user.name"
              :error-messages="objectErrors(this.$v.user.name)"
              :counter="this.$v.user.name.$params.maxLength.max"
              @input="$v.user.name.$touch()"
              @blur="$v.user.name.$touch()"
            ></v-text-field>
          </v-col>

          <v-col
            cols="4"
            class="pr-0 pl-1"
          >
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-switch
                    dense
                    hide-details
                    v-model="user.printOnDocs"
                    class="my-0 pl-4 pr-1"
                    label="Доверенность"
                  ></v-switch>
                </div>
              </template>
              <span>Если у пользователя есть доверенность, то его имя будет попадать в документы</span>
            </v-tooltip>
          </v-col>

          <v-col v-if="user.id < 0">
            <v-text-field
              autocomplete="off"
              type="text"
              label="Пароль"
              :error-messages="objectErrors(this.$v.user.password)"
              @input="$v.user.password.$touch()"
              @blur="$v.user.password.$touch()"
              v-model="user.password"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-8">
        <v-spacer></v-spacer>
        <v-btn
          class="px-6"
          outlined
          @click.prevent="cancelClick"
        >Отмена</v-btn>
        <v-btn
          class="px-12"
          color="primary"
          @click.prevent="okClick"
          :loading="loading"
        >OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CargoTypeSelector from '@/components/CargoTypeSelector'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  props: {
    value: Object, // показать диалог если есть открываемый элемент
    saveCallback: Function
  },

  data: () => ({
    user: {},
    loading: false,
    rolesLoading: false,
    roles: []
  }),

  watch: {
    value (val) {
      this.user = {
        ...val,
        // если пользователь есть, но это пустой объект, то дать ему id = -1, если null, то 0 иначе id
        id: val?.id ? val.id : val ? -1 : 0,
        // подстава с паролем - его нельзя апдейтить, но правила валидации на добавление и изменение едины
        // поэтому при изменении подкидываем ***
        password: val?.id ? '********' : '',
        // подстава с cargoTypeID, он nullable, но тогда не приходит поле, а оно required и нужен 0 по умолчанию
        // либо значение которое забито юзеру
        cargoTypeID: val?.cargoTypeID ? val.cargoTypeID : this.$store.state.auth.user.cargoTypeID ?? 0
      }
    }
  },

  computed: {
    show: {
      get () {
        // показываем если id != 0
        return this.user.id
      },
      set (val) {
        this.$v.$reset()
        if (!val) {
          // сбрасываем объект, который передавали в диалог
          this.$emit('input', null)
        }
      }
    }
  },

  validations () {
    return {
      user: {
        cargoTypeID: { required },
        name: { required, minLength: minLength(6), maxLength: maxLength(80) },
        login: { required, minLength: minLength(3), maxLength: maxLength(40) },
        password: { required, minLength: minLength(4), maxLength: maxLength(16) },
        role: { required }
      }
    }
  },

  created () {
    this.rolesLoading = true
    this.axios
      .get('/users/roles')
      .then(response => {
        this.roles = response.data
        this.rolesLoading = false
      })
      .catch(() => {
        this.$router.push('/error?message=Ошибка при загрузке ролей пользователей')
      })
  },

  methods: {
    objectErrors (obj) {
      if (!obj.$dirty) return []
      const errors = []

      obj.$params.maxLength &&
        !obj.maxLength &&
        errors.push(`Не более ${obj.$params.maxLength.max} символов, пожалуйста`)

      obj.$params.minLength &&
        !obj.minLength &&
        errors.push(`Не менее ${obj.$params.minLength.min} символов, пожалуйста`)

      obj.$params.required && !obj.required && errors.push('Введите значение')
      return errors
    },

    async okClick () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.loading = true
      const res = await this.saveCallback(this.user)
      if (res) {
        this.show = false
      }
      this.loading = false
    },

    cancelClick () {
      this.show = false
    }
  },

  components: {
    CargoTypeSelector
  }
}
</script>
